import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-697fb424"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "update-developer-form"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "items-in-line gap--5" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 5 }
const _hoisted_6 = { key: 8 }
const _hoisted_7 = {
  key: 0,
  class: "third-color xs-font-size"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Вы уверены, что хотите удалить файл?", -1))
const _hoisted_9 = { class: "items-in-line" }

import { ErrorsType, ParamsDataType } from '@/types';
import { vMaska } from 'maska';
import { ValidationRuleWithoutParams } from '@vuelidate/core';
import { ParamsValuesType } from '@/api/developer/types';
import { UpdateCategories } from '@/components';
import { onMounted, ref, Ref } from 'vue';
import { deleteFileApi } from '@/api/developer';
import { FileParamType } from '@/types/UpdateDeveloperTypes';
import MapModal from './MapModal/MapModal.vue';
import type { LngLat } from '@yandex/ymaps3-types';

type addressIdsType = {
  pointId: number | undefined;
  addressId: number | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateForm',
  props: /*#__PURE__*/_mergeModels({
    params: {},
    errors: {},
    rules: {},
    parentId: {}
  }, {
    "paramsData": {},
    "paramsDataModifiers": {},
    "v$": {},
    "v$Modifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels([
  'validationErrorsHandlerByKey',
  'inputTouch',
  'focus',
  'changeCategory',
  'createCategory',
  'deleteCategory',
  'update:paramsData',
  'deleteFile',
], ["update:paramsData", "update:v$"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
// eslint-disable-next-line no-undef
const paramsData = _useModel<ParamsDataType>(__props, 'paramsData');
// eslint-disable-next-line no-undef
const v$ = _useModel<ParamsDataType>(__props, 'v$');

const addressIds = [
  {
    pointId: 226,
    addressId: 250,
  },
  {
    pointId: 225,
    addressId: 88,
  },
];
const activeAddressIds: Ref<{
  addressIdsType;
}> = ref({
  pointId: undefined,
  addressId: undefined,
});
const modalData: Ref<{
  show: boolean;
  fileId: undefined | number;
  inputId: undefined | number;
  btnLoading: boolean;
}> = ref({
  show: false,
  fileId: undefined,
  inputId: undefined,
  btnLoading: false,
});
const mapModalData: Ref<{
  show: boolean;
  point: LngLat | undefined;
  addressValue: string | undefined;
}> = ref({
  show: false,
  point: undefined,
  addressValue: undefined,
});
const openModal = (inputId: number, fileId: number) => {
  modalData.value = {
    show: true,
    fileId: fileId,
    inputId: inputId,
    btnLoading: false,
  };
};
const closeModal = () => {
  modalData.value = {
    show: false,
    fileId: undefined,
    inputId: undefined,
    btnLoading: false,
  };
};

const deleteFile = async () => {
  if (modalData.value.fileId && paramsData.value && modalData.value.inputId) {
    try {
      modalData.value.btnLoading = true;

      const res = await deleteFileApi(modalData.value.fileId);

      if (res) {
        // useAppStore().openInfoModal('Файл удален');
        (paramsData.value[modalData.value.inputId].value as FileParamType).oldValue = (
          paramsData.value[modalData.value.inputId].value as FileParamType
        ).oldValue!.filter(el => el.id !== modalData.value.fileId);
      }
    } finally {
      closeModal();
    }
  }
};

const changeAddressValue = (data: { point: [string, string]; address?: string }) => {
  if (activeAddressIds.value.pointId) {
    paramsData.value[activeAddressIds.value?.pointId].value.min = data.point[1];
    paramsData.value[activeAddressIds.value?.pointId].value.max = data.point[0];
    if (data.address) {
      paramsData.value[activeAddressIds.value?.addressId].value = data.address;
    }
  }
};

const showMapBlock = (point: LngLat) => {
  mapModalData.value = {
    show: true,
    point: [+point[0], +point[1]],
    addressValue: paramsData.value[activeAddressIds.value?.addressId]?.value,
  };
};
const closeMapBlock = () => {
  mapModalData.value = {
    show: false,
    point: undefined,
    addressValue: undefined,
  };
};

onMounted(() => {
  addressIds.forEach(el => {
    if (paramsData.value[el.pointId] && paramsData.value[el.addressId]) {
      activeAddressIds.value = { ...el };
    }
  });
});

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_address_input = _resolveComponent("base-address-input")!
  const _component_base_date_picker = _resolveComponent("base-date-picker")!
  const _component_base_checkbox_input = _resolveComponent("base-checkbox-input")!
  const _component_base_file_input = _resolveComponent("base-file-input")!
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_textarea = _resolveComponent("base-textarea")!
  const _component_base_modal = _resolveComponent("base-modal")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createBlock(_component_base_form, null, {
    default: _withCtx(() => [
      (paramsData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.params, (input) => {
              return (_openBlock(), _createElementBlock("div", null, [
                (input.type === 24 || input.type === 25 || input.type === 28)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_base_input, {
                          modelValue: paramsData.value[String(input.id)].value.min,
                          "onUpdate:modelValue": ($event: any) => ((paramsData.value[String(input.id)].value.min) = $event),
                          error: _ctx.errors[String(input.id)],
                          invalid: !!_ctx.errors[String(input.id)],
                          label: input.title + ' от',
                          type: input.type === 24 || input.type === 25 ? 'number' : 'text',
                          height: "34",
                          hideArrows: "",
                          "with-bg": "",
                          onBlur: ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', input.id)),
                          onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                          onInput: ($event: any) => (_ctx.$emit('inputTouch', input.id))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "invalid", "label", "type", "onBlur", "onFocus", "onInput"]),
                        _createVNode(_component_base_input, {
                          modelValue: paramsData.value[String(input.id)].value.max,
                          "onUpdate:modelValue": ($event: any) => ((paramsData.value[String(input.id)].value.max) = $event),
                          invalid: !!_ctx.errors[String(input.id)],
                          label: input.title + ' до',
                          type: input.type === 24 || input.type === 25 ? 'number' : 'text',
                          height: "34",
                          hideArrows: "",
                          "with-bg": "",
                          onBlur: ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', input.id)),
                          onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                          onInput: ($event: any) => (_ctx.$emit('inputTouch', input.id))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid", "label", "type", "onBlur", "onFocus", "onInput"]),
                        (input.type === 28 && input.id === activeAddressIds.value.pointId)
                          ? (_openBlock(), _createBlock(_component_base_button, {
                              key: 0,
                              height: "34",
                              icon: "",
                              "style-type": "white",
                              width: "34",
                              "without-active": "",
                              onClick: ($event: any) => (
                showMapBlock([
                  paramsData.value[String(input.id)].value.max,
                  paramsData.value[String(input.id)].value.min,
                ])
              )
                            }, {
                              text: _withCtx(() => [
                                _createVNode(_component_base_image, {
                                  src: require('@/assets/img/banner/icon-for-map.svg'),
                                  contain: "",
                                  height: "34",
                                  name: "map",
                                  width: "20"
                                }, null, 8, ["src"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (input.id === activeAddressIds.value.addressId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_base_address_input, {
                          modelValue: paramsData.value[String(input.id)].value,
                          "onUpdate:modelValue": ($event: any) => ((paramsData.value[String(input.id)].value) = $event),
                          label: input.title,
                          height: "36",
                          onChangeLocation: _cache[0] || (_cache[0] = ($event: any) => (changeAddressValue({ point: $event })))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                      ]))
                    : (
            input.type === 12 ||
            input.type === 13 ||
            input.type === 19 ||
            input.type === 20
          )
                      ? (_openBlock(), _createBlock(_component_base_date_picker, {
                          key: 2,
                          modelValue: paramsData.value[String(input.id)].value,
                          "onUpdate:modelValue": ($event: any) => ((paramsData.value[String(input.id)].value) = $event),
                          error: _ctx.errors[String(input.id)],
                          flow: ['year', 'month', 'calendar'],
                          label: input.title,
                          "month-picker": input.type === 20,
                          "year-picker": input.type === 19,
                          height: "36",
                          "with-bg": "",
                          onBlur: ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', input.id)),
                          onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                          onInput: ($event: any) => (_ctx.$emit('inputTouch', input.id))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "label", "month-picker", "year-picker", "onBlur", "onFocus", "onInput"]))
                      : (input.type === 3)
                        ? (_openBlock(), _createBlock(_component_base_checkbox_input, {
                            key: 3,
                            modelValue: paramsData.value[String(input.id)].value,
                            "onUpdate:modelValue": ($event: any) => ((paramsData.value[String(input.id)].value) = $event),
                            error: _ctx.errors[String(input.id)],
                            label: input.title,
                            height: "36",
                            onBlur: ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', input.id)),
                            onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                            onInput: ($event: any) => (_ctx.$emit('inputTouch', input.id))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "label", "onBlur", "onFocus", "onInput"]))
                        : (
            input.type === 10 ||
            input.type === 11 ||
            input.type === 26 ||
            input.type === 15
          )
                          ? (_openBlock(), _createBlock(_component_base_file_input, {
                              key: 4,
                              modelValue: paramsData.value[String(input.id)].value.newValue,
                              "onUpdate:modelValue": ($event: any) => ((paramsData.value[String(input.id)].value.newValue) = $event),
                              files: paramsData.value[String(input.id)].value.oldValue,
                              label: input.title,
                              multiple: input.type === 11 || input.type === 26,
                              "with-bg": "",
                              withIcon: "",
                              onDeleteFile: ($event: any) => (openModal(input.id, $event)),
                              onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                              onUpdate: ($event: any) => (paramsData.value[input.id] = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "files", "label", "multiple", "onDeleteFile", "onFocus", "onUpdate"]))
                          : (input.type === 4 || input.type === 14 || input.type === 30)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (_openBlock(), _createBlock(_component_base_select_input, {
                                  key: input.id,
                                  modelValue: paramsData.value[String(input.id)].value,
                                  "onUpdate:modelValue": ($event: any) => ((paramsData.value[String(input.id)].value) = $event),
                                  error: _ctx.errors[String(input.id)],
                                  isMulti: input.type === 14,
                                  label: input.title,
                                  options: input.list,
                                  searchCount: 
              input.options['search2-visual'] === '15' ||
              input.options['search2-visual'] === '13'
                ? 5
                : 7
            ,
                                  arrow: "expand_more",
                                  clearable: "",
                                  height: "36",
                                  textKey: "value",
                                  "with-bg": "",
                                  onBlur: ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', input.id)),
                                  onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                                  onInput: ($event: any) => (_ctx.$emit('inputTouch', input.id))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "isMulti", "label", "options", "searchCount", "onBlur", "onFocus", "onInput"]))
                              ]))
                            : (input.type === 23)
                              ? _withDirectives((_openBlock(), _createBlock(_component_base_input, {
                                  key: 6,
                                  modelValue: paramsData.value[input.id].value,
                                  "onUpdate:modelValue": ($event: any) => ((paramsData.value[input.id].value) = $event),
                                  error: _ctx.errors[String(input.id)],
                                  invalid: !!_ctx.errors[String(input.id)],
                                  label: input.title,
                                  "data-maska": "##:##:######:##",
                                  height: "36",
                                  hideArrows: "",
                                  placeholder: "47:14:120301:814",
                                  "with-bg": "",
                                  onBlur: ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', input.id)),
                                  onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                                  onInput: ($event: any) => (_ctx.$emit('inputTouch', input.id))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "invalid", "label", "onBlur", "onFocus", "onInput"])), [
                                  [_unref(vMaska)]
                                ])
                              : (input.type === 8)
                                ? _withDirectives((_openBlock(), _createBlock(_component_base_input, {
                                    key: 7,
                                    modelValue: paramsData.value[input.id].value,
                                    "onUpdate:modelValue": ($event: any) => ((paramsData.value[input.id].value) = $event),
                                    error: _ctx.errors[String(input.id)],
                                    invalid: !!_ctx.errors[String(input.id)],
                                    label: input.title,
                                    "data-maska": "(###)###-##-##",
                                    height: "36",
                                    hideArrows: "",
                                    placeholder: "+7 (999)000-99-99",
                                    prefix: "+7 ",
                                    "with-bg": "",
                                    onBlur: ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', input.id)),
                                    onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                                    onInput: ($event: any) => (_ctx.$emit('inputTouch', input.id))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "invalid", "label", "onBlur", "onFocus", "onInput"])), [
                                    [_unref(vMaska)]
                                  ])
                                : (input.type === 22)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                      _createVNode(_unref(UpdateCategories), {
                                        "category-id": input.options['list-category'],
                                        "editable-category": input.value,
                                        "parent-id": _ctx.parentId,
                                        title: input.title,
                                        "is-input": "",
                                        onChangeCategory: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeCategory', $event))),
                                        onCreateCategory: ($event: any) => (_ctx.$emit('createCategory', [$event, input.id])),
                                        onDeleteCategory: ($event: any) => (_ctx.$emit('deleteCategory', [$event, input.id]))
                                      }, null, 8, ["category-id", "editable-category", "parent-id", "title", "onCreateCategory", "onDeleteCategory"])
                                    ]))
                                  : (input.type === 7 || input.type === 1)
                                    ? (_openBlock(), _createBlock(_component_base_textarea, {
                                        key: 9,
                                        modelValue: paramsData.value[String(input.id)].value,
                                        "onUpdate:modelValue": ($event: any) => ((paramsData.value[String(input.id)].value) = $event),
                                        error: _ctx.errors[String(input.id)],
                                        invalid: !!_ctx.errors[String(input.id)],
                                        label: input.title,
                                        height: "36",
                                        "max-height": "150",
                                        textarea: "",
                                        withScroll: "",
                                        onBlur: ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', input.id)),
                                        onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                                        onInput: ($event: any) => (_ctx.$emit('inputTouch', input.id))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "invalid", "label", "onBlur", "onFocus", "onInput"]))
                                    : (_openBlock(), _createBlock(_component_base_input, {
                                        key: 10,
                                        modelValue: paramsData.value[String(input.id)].value,
                                        "onUpdate:modelValue": ($event: any) => ((paramsData.value[String(input.id)].value) = $event),
                                        error: _ctx.errors[String(input.id)],
                                        invalid: !!_ctx.errors[String(input.id)],
                                        isPercent: input.type === 6,
                                        label: input.title,
                                        max: 
            input.type === 6 ? 100 : input.options.max ? +input.options.max : undefined
          ,
                                        min: input.options.min ? +input.options.min : undefined,
                                        styles: { border: '1px solid #94857d' },
                                        type: 
            input.type === 2 || input.type === 5 || input.type === 6 ? 'number' : 'text'
          ,
                                        height: "36",
                                        hideArrows: "",
                                        "with-bg": "",
                                        onBlur: ($event: any) => (_ctx.$emit('validationErrorsHandlerByKey', input.id)),
                                        onFocus: ($event: any) => (_ctx.$emit('focus', input.id)),
                                        onInput: ($event: any) => (_ctx.$emit('inputTouch', input.id))
                                      }, {
                                        appendIcon: _withCtx(() => [
                                          (input.type === 27)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "метр."))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "error", "invalid", "isPercent", "label", "max", "min", "type", "onBlur", "onFocus", "onInput"]))
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_base_modal, {
        "show-modal": modalData.value.show,
        "hide-title": "",
        onClose: closeModal
      }, {
        content: _withCtx(() => [
          _hoisted_8
        ]),
        btn: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_base_button, {
              height: "40",
              "style-type": "border",
              text: "Отмена",
              width: "118",
              onClick: closeModal
            }),
            _createVNode(_component_base_button, {
              loading: modalData.value.btnLoading,
              height: "40",
              text: "Да",
              width: "118",
              onClick: deleteFile
            }, null, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["show-modal"]),
      _createVNode(MapModal, {
        "address-value": mapModalData.value.addressValue,
        point: mapModalData.value.point,
        "show-modal": mapModalData.value.show,
        onChangePoint: changeAddressValue,
        onClose: closeMapBlock
      }, null, 8, ["address-value", "point", "show-modal"])
    ]),
    _: 1
  }))
}
}

})